import { H5 } from '@liveauctioneers/hammer-ui-core/text';

import PageTitle from '@/components/PageTitle/PageTitle';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import FeaturesPageHeaderMeta from './FeaturesPageHeaderMeta';

const sectionBodyClasses = 'hui-text-body-primary pb-sm text-sm';

const FeaturesPage = () => {
    const formatMessage = useAppFormatMessage();

    return (
        <div className="mx-auto max-w-dense px-sm pb-lg">
            <FeaturesPageHeaderMeta />
            <PageTitle title={formatMessage('features_and_services')} />
            <div>
                <p className={sectionBodyClasses}>{formatMessage('feature_blurb')}</p>

                <H5 className="font-medium">{formatMessage('live_bidding')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('live_bidding_blurb')}</p>

                <H5 className="font-medium">{formatMessage('absentee_bidding')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('absentee_bidding_blurb')}</p>

                <H5 className="font-medium">{formatMessage('auctioneer_dashboard')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('auctioneer_dashboard_blurb')}</p>

                <H5 className="font-medium">{formatMessage('our_network')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('our_network_blurb')}</p>
                <div className="pb-sm text-center">
                    <img
                        alt="Our network"
                        className="w-full max-w-[700px]"
                        src="https://images.liveauctioneers.com/static/network.jpg"
                    />
                </div>

                <H5 className="font-medium">{formatMessage('catalog_set_up')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('catalog_set_up_blurb')}</p>

                <H5 className="font-medium">{formatMessage('bidder_management')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('bidder_management_blurb')}</p>

                <H5 className="font-medium">{formatMessage('inbox_messaging')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('inbox_messaging_blurb')}</p>

                <H5 className="font-medium">{formatMessage('statistics_tracking')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('statistics_tracking_blurb')}</p>

                <H5 className="font-medium">{formatMessage('self_service_upload')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('self_service_upload_blurb')}</p>

                <H5 className="font-medium">{formatMessage('automated_online_console')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('automated_online_console_blurb')}</p>

                <H5 className="font-medium">{formatMessage('end_of_auction_report')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('end_of_auction_report_blurb')}</p>

                <H5 className="font-medium">{formatMessage('qr_code')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('qr_code_blurb')}</p>

                <H5 className="font-medium">{formatMessage('staff_permission_levels')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('staff_permission_levels_blurb')}</p>

                <H5 className="font-medium">{formatMessage('weekly_newsletter')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('weekly_newsletter_blurb')}</p>

                <H5 className="font-medium">{formatMessage('help_files')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('help_files_blurb')}</p>

                <H5 className="font-medium">{formatMessage('bidder_contact_and_invoicing')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('bidder_contact_and_invoicing_blurb')}</p>

                <H5 className="font-medium">{formatMessage('paypal')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('paypal_blurb')}</p>

                <H5 className="font-medium">{formatMessage('accounting')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('accounting_blurb')}</p>

                <H5 className="font-medium">{formatMessage('white_label_platform')}</H5>
                <p className={sectionBodyClasses}>{formatMessage('white_label_platform_blurb')}</p>
            </div>
        </div>
    );
};

export default FeaturesPage;
